import { memo } from "react";
import { Radio } from "components/inputs/Radio";
import { PREFERENCES } from "./constants";
import "./GifPreferenceList.scss";

interface IGifPreferenceList {
  selected: typeof PREFERENCES[number];
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const GifPreferenceList: React.FC<IGifPreferenceList> = memo(({
  selected,
  onChange
}) => {
  return (
    <ul className="GifPreferenceList">
      {PREFERENCES.map(preference => (
        <li key={preference} className="GifPreferenceList-Item">
          <Radio
            label={preference}
            name={preference}
            value={preference}
            checked={preference === selected}
            onChange={onChange}
          />
        </li>
      ))}
    </ul>
  );
});
